module.exports = __webpack_public_path__ + "static/media/SketchPngac24b57d4fdf048ee216b4d1e57adb8884388eb936dec316267c11d60bcdda8e.ac746151.png";